import React from 'react';
import { NavigationMenuItem } from '@models/navigation';
import SocialMediaItem from './SocialMediaItem';

type Props = {
  socialMediaIcons: Array<NavigationMenuItem>,
  width?: number,
}

export default function SocialMediaIcons({ socialMediaIcons, width }:Props) {
  const socialMediaVisibleList = socialMediaIcons.slice(0, 3)
    .map((item:any) => <SocialMediaItem key={item.id} item={item} width={width} />);

  return (
    <div className="relative hidden lg:block">
      <div className="flex items-center justify-end">
        {socialMediaVisibleList}
      </div>
    </div>
  );
}

SocialMediaIcons.defaultProps = {
  width: 30,
};
